import type { PlanningReport, PostReference } from '../../campaign-analysis/types';

const CDN = 'https://d1u30siow2tw3d.cloudfront.net';

function post(tiktokId: string, tiktokUrl: string): PostReference {
  return {
    videoUrl: `${CDN}/posts/videos/tiktok/${tiktokId}_0.mp4`,
    posterUrl: `${CDN}/posts/posters/tiktok/${tiktokId}_0.jpeg`,
    sourceUrl: tiktokUrl,
  };
}

const P = {
  '5c13': post('7639188658410556702', 'https://www.tiktok.com/@luna350782/video/7639188658410556702'),
  '5c16': post('7645816803913977101', 'https://www.tiktok.com/@andro_diaz/video/7645816803913977101'),
  '5c0e': post('7642143272441351438', 'https://www.tiktok.com/@katie.sleepyhead/video/7642143272441351438'),
  '5cb5': post('7534142614887615774', 'https://www.tiktok.com/@sapphiredelight2.0/video/7534142614887615774'),
  '5c21': post('7639029964926438686', 'https://www.tiktok.com/@luna350782/video/7639029964926438686'),
  '5c10': post('7632073630909762846', 'https://www.tiktok.com/@marzipannnn/video/7632073630909762846'),
  '5c12': post('7639399949481921823', 'https://www.tiktok.com/@itzesantana11/video/7639399949481921823'),
  '5c1d': post('7633162820783181086', 'https://www.tiktok.com/@thesnasan/video/7633162820783181086'),
  '5c23': post('7632905143326985485', 'https://www.tiktok.com/@akbeautytips/video/7632905143326985485'),
  '5cc9': post('7598277098339372319', 'https://www.tiktok.com/@elizabeth.gonzale11/video/7598277098339372319'),
};

export const beautySupplementPlanning: PlanningReport = {
  id: 'onist-revenue-score-2026-06-16',
  title: "오니스트 — 'Revenue score' (2026.06.16)",
  titleEn: "Ownist — 'Revenue score' (2026.06.16)",
  subtitle: "343개 포스트 분석 · TikTok 미국 뷰티·웰니스 · K2O/KO by Kylie Jenner 스킨케어 드링크 & 서플리먼트",
  subtitleEn: "343 posts analyzed · TikTok US Beauty & Wellness · K2O/KO by Kylie Jenner skincare drinks & supplements",
  platform: 'TikTok',
  market: 'US',
  metric: 'Revenue score',
  postsAnalyzed: 343,
  period: '2025년 5월 ~ 2026년 6월',
  periodEn: 'May 2025 – June 2026',
  creatorGuidePrompts: [
    {
      label: '20대 영어권 여성 크리에이터',
      labelEn: 'Young English-speaking female creator',
      prompt:
        '25~30세 여성 크리에이터, 영어권, 미국 거주. 뷰티 서플리먼트 또는 스킨케어 드링크 카테고리 경험 보유. 팔로워 1만~10만 명. 일상 공간에서 자연스럽게 촬영하고, 배경음악을 적극 활용하며, 광고보다 친구에게 공유하는 듯한 진정성 있는 소통 스타일.',
      promptEn:
        'Female creator, age 25–30, English-speaking, US-based. Experience with beauty supplements or skincare drinks. 10K–100K followers. Films naturally in everyday spaces, actively uses trending background music, authentic "sharing with a friend" communication style over polished ads.',
    },
    {
      label: '히스패닉 스페인어권 여성 크리에이터',
      labelEn: 'Hispanic Spanish-speaking female creator',
      prompt:
        '25~35세 히스패닉 여성 크리에이터, 스페인어 사용, 미국 거주. 뷰티 또는 건강 제품 콘텐츠 경험 보유. 팔로워 1만~10만 명. 스페인어 커뮤니티 대상 진정성 있는 개인 증언 스타일로 촬영.',
      promptEn:
        'Hispanic female creator, age 25–35, Spanish-speaking, US-based. Experience creating beauty or health product content. 10K–100K followers. Authentic personal testimony style targeting the Spanish-speaking community.',
    },
    {
      label: '아시아계 미국 여성 크리에이터',
      labelEn: 'Asian-American female creator',
      prompt:
        '22~30세 아시아계 또는 아시아계 미국인 여성 크리에이터, 영어 사용, 미국 거주. 스킨케어 또는 뷰티 서플리먼트 Before-After 포맷 경험 보유. 팔로워 1만~10만 명. 자연광 촬영, 최소한의 편집, 진솔한 제품 반응을 보여주는 스타일.',
      promptEn:
        'Asian or Asian-American female creator, age 22–30, English-speaking, US-based. Experience with skincare or beauty supplement Before-After formats. 10K–100K followers. Natural lighting, minimal editing, genuine product reactions.',
    },
  ],
  insights: [
    {
      type: 'do',
      title: '액체형(드링크·파우더 믹스) 제품을 홍보하라',
      titleEn: 'Promote liquid-form (drink / powder mix) products',
      detail:
        '액체형·드링크 제품을 홍보한 포스트는 젤리 형태 포스트보다 압도적으로 높은 매출 성과를 기록했습니다. 드링크는 마시는 순간의 색감·소리·맛 반응을 생생하게 포착할 수 있어, 시청자의 감각적 공감을 이끌어내는 콘텐츠 제작에 유리합니다.',
      detailEn:
        'Posts promoting liquid or drink-form supplements dramatically outperformed gummy posts in revenue. Drinks allow creators to vividly capture color, sound, and taste reactions in real time, making sensory content that resonates with viewers far easier to produce.',
      uplift: '액체형 포스트의 매출 집중도가 압도적',
      upliftEn: 'Liquid-form posts generate a disproportionately large share of total revenue',
      tags: ['액체형', '드링크', '파우더 믹스', '제품 유형'],
      tagsEn: ['Liquid form', 'Drinks', 'Powder mix', 'Product type'],
      referencePosts: [P['5c13'], P['5c16'], P['5c0e']],
      actionInstruction:
        '시청자가 드링크를 따르고 마시는 장면을 보는 순간 "나도 마시고 싶다"는 욕구가 생기도록 연출하세요. 영상 마지막에 구매 링크 CTA를 배치하고, 감각적인 음료 장면을 CTA 직전에 한 번 더 반복해 전환 욕구를 극대화하세요.',
      actionInstructionEn:
        'Direct viewers to feel "I want to drink that too" when they see the pouring and drinking scene. Place a direct purchase CTA at the end, and repeat a sensory drink shot just before the CTA to maximize conversion impulse.',
      contentGuide:
        '유리잔에 드링크를 따르는 클로즈업으로 영상을 시작하세요. 색감·거품·소리가 담긴 ASMR 감각의 샷을 찍고, 첫 모금을 마시는 순간의 진짜 표정 반응은 편집하지 마세요. 제품 패키지가 선명하게 보이는 샷을 반드시 포함하고, 마지막 5초에 구매 링크 CTA를 배치하세요.',
      contentGuideEn:
        'Start your video with a close-up of pouring the drink into a glass. Capture ASMR-style shots showing the color, foam, and pour sound. Do not edit your first-sip reaction — keep it genuine. Include at least one clear product packaging shot, and place your purchase link CTA in the final 5 seconds.',
    },
    {
      type: 'do',
      title: '셀럽/유명 브랜드 이름을 영상 첫 2초 내에 노출하라',
      titleEn: 'Feature the celeb/brand name within the first 2 seconds',
      detail:
        '카일리 제너의 브랜드를 홍보한 포스트는 비셀럽 브랜드 포스트보다 월등히 높은 매출 성과를 기록했습니다. 셀럽 이름이 천장을 높이는 역할을 할 뿐이며, 실제 매출은 콘텐츠 실행 전략이 결정합니다.',
      detailEn:
        'Posts promoting Kylie Jenner\'s brand significantly outperformed non-celebrity brand posts in revenue. The celebrity name raises the ceiling, but execution strategy is what ultimately drives actual revenue.',
      uplift: '셀럽 브랜드 포스트의 매출 우위가 뚜렷함',
      upliftEn: 'Celebrity brand posts show a clear and significant revenue advantage',
      tags: ['셀럽 브랜드', 'KO by Kylie Jenner', 'K2O'],
      tagsEn: ['Celebrity brand', 'KO by Kylie Jenner', 'K2O'],
      referencePosts: [P['5c13'], P['5c16'], P['5c10']],
      actionInstruction:
        '영상 첫 2초 이내에 브랜드 이름이나 권위 있는 연관 키워드를 텍스트 또는 음성으로 노출해 시청자의 스크롤을 즉시 멈추게 하세요. 브랜드와의 연결고리를 전면에 내세워 호기심을 구매 욕구로 전환하세요.',
      actionInstructionEn:
        'Surface the brand name or an authoritative keyword in text or audio within the first 2 seconds to stop the scroll. Lead with the brand connection to convert curiosity into purchase intent.',
      contentGuide:
        '영상 오프닝에 텍스트 오버레이로 브랜드명을 강조하세요. 제품 패키지의 로고가 카메라를 향하도록 촬영하고, 브랜드 스토리를 자연스럽게 언급하세요. "나도 써봤더니…" 형식의 실제 경험 공유 톤을 유지하고, 광고처럼 보이지 않도록 주의하세요.',
      contentGuideEn:
        'Use a text overlay to highlight the brand name in your opening clip. Film the product with its logo facing the camera and naturally mention the brand story. Keep a tone of genuine personal experience — "I tried it and…" — and make sure your video does not look like an advertisement.',
    },
    {
      type: 'do',
      title: '"변화 전·후(Before-After)" 스토리텔링에 "품절 임박" 메시지를 결합하라',
      titleEn: 'Combine Before-After transformation storytelling with urgency messaging',
      detail:
        'Before-After 변화 내러티브와 희소성·긴급성 메시지를 함께 사용한 포스트는 전체 평균보다 훨씬 높은 매출을 기록했습니다. 두 요소 중 하나만 사용할 경우 효과가 거의 없으므로, 반드시 두 가지를 조합해야 합니다.',
      detailEn:
        'Posts combining Before-After transformation storytelling with scarcity or urgency messaging dramatically outperformed the overall average. Using only one of the two elements yields almost no uplift — they must always be used together.',
      uplift: 'Before-After + 긴급성 조합은 단독 사용 대비 효과 압도적',
      upliftEn: 'Before-After + urgency combination far outperforms either element used alone',
      tags: ['Before-After', 'FOMO', '품절 임박', '조합 전략'],
      tagsEn: ['Before-After', 'FOMO', 'Selling out', 'Combination strategy'],
      referencePosts: [P['5c13'], P['5c0e'], P['5c10']],
      actionInstruction:
        '영상 후반부에 "지금 구매하지 않으면 놓친다"는 심리적 압박을 조성하세요. "이번 주 한정 프로모션", "재고 마감 임박", "빠르게 품절되고 있어요" 같은 긴급성 메시지를 Before-After 결과 공개 직후에 배치해 전환을 극대화하세요.',
      actionInstructionEn:
        'Create psychological urgency in the latter half of the video. Place urgency messages such as "this week only," "almost sold out," or "selling out fast" immediately after revealing the Before-After result to maximize conversion.',
      contentGuide:
        '영상을 세 단계로 구성하세요: ① 필터 없는 "전" 장면(고민 표현) → ② "3주 후" 타임스탬프와 함께 변화 결과 → ③ "품절 임박" 긴급 CTA. "전" 장면은 꾸밈없이, "후" 장면은 자연광에서 촬영하고, 두 장면 간 전환은 빠르게 편집하세요.',
      contentGuideEn:
        'Structure your video in three acts: ① An unfiltered "before" scene showing your struggle → ② A clear transformation result with a "3 weeks later" timestamp → ③ An urgent CTA such as "almost sold out." Shoot your "before" without filters, your "after" in natural light, and cut between them snappily.',
    },
    {
      type: 'do',
      title: '갈등·호기심을 유발하는 충격적인 첫 3초 훅(Hook)을 사용하라',
      titleEn: 'Open with a conflict- or curiosity-driven hook in the first 3 seconds',
      detail:
        '갈등 기반 훅으로 시작한 포스트는 단순 제품 소개로 시작하는 포스트보다 훨씬 높은 매출 성과를 기록했습니다. 충격적인 질문이나 비교 상황으로 첫 3초를 열어야 스크롤을 멈추고 시청 완주율을 높일 수 있습니다.',
      detailEn:
        'Posts opening with a conflict-based hook significantly outperformed those starting with a simple product introduction. A shocking question or comparison challenge in the first 3 seconds is what stops the scroll and drives view-through.',
      uplift: '갈등 훅 포스트의 매출 우위 확인',
      upliftEn: 'Conflict-based hook posts show clear revenue superiority',
      tags: ['갈등 기반 훅', '첫 3초', '호기심', '패턴 인터럽트'],
      tagsEn: ['Conflict-based hook', 'First 3 seconds', 'Curiosity', 'Pattern interrupt'],
      referencePosts: [P['5c16'], P['5c0e']],
      actionInstruction:
        '영상 첫 3초에 시청자가 "이게 뭐지?"라고 멈추게 만드는 갈등·의문 상황을 설정하세요. "이 중 하나는 맛이 없어요", "POV: 처음엔 믿지 않았는데…" 같은 문구가 조기 이탈을 방지하고 시청 완주율을 높입니다.',
      actionInstructionEn:
        'Set up a conflict or question in the first 3 seconds that makes viewers stop and think "what is this?" Lines like "one of these tastes awful" or "POV: I didn\'t believe it at first…" prevent early drop-offs and drive view-through rate.',
      contentGuide:
        '절대 제품 소개로 영상을 시작하지 마세요. 충격적인 질문, 비교 도전, 또는 공감 고백 중 하나로 영상의 첫 장면을 시작하세요. 훅은 2~3초 이내로 짧게 유지하고, 바로 이어서 제품을 등장시키세요.',
      contentGuideEn:
        'Do not open your video with a product introduction. Start with a shocking question, a comparison challenge, or a relatable confession. Keep your hook under 2–3 seconds, then bring the product in immediately after.',
    },
    {
      type: 'do',
      title: '30세 미만의 젊은 크리에이터를 우선 선발하라',
      titleEn: 'Prioritize creators under 30 years old',
      detail:
        '30세 미만 크리에이터가 40대 이상보다 일관되게 높은 매출 성과를 보였으며, 크리에이터 연령과 매출 성과 사이에는 뚜렷한 음의 상관관계가 확인됩니다. 배경음악을 활용한 포스트도 무음 포스트보다 유의미하게 높은 성과를 기록했습니다.',
      detailEn:
        'Creators under 30 consistently outperformed those in their 40s, with a clear negative correlation confirmed between creator age and revenue performance. Posts with background music also significantly outperformed silent posts.',
      uplift: '30세 미만 + 배경음악 조합이 주요 성공 변수',
      upliftEn: 'Under-30 creators paired with background music are a key success variable',
      tags: ['크리에이터 연령', '30세 미만', '배경음악'],
      tagsEn: ['Creator age', 'Under 30', 'Background music'],
      referencePosts: [P['5c13'], P['5c16'], P['5c10']],
      actionInstruction:
        '진정성 있고 자연스러운 소통 방식을 가진 25~30세 크리에이터를 우선하세요. 유행 배경음악을 활용하고, 지나치게 편집된 광고 느낌 대신 친구에게 공유하는 듯한 리얼한 콘텐츠를 요청하세요.',
      actionInstructionEn:
        'Prioritize creators aged 25–30 with authentic and natural communication styles. Use trending background music and request real, friend-to-friend-style content rather than overly polished ad-like videos.',
      contentGuide:
        '침실·부엌·차 안 같은 일상 공간에서 자연스럽게 제품을 사용하는 장면을 촬영하세요. 유행하는 배경음악을 사용하고, 스크립트를 최소화해 자연스러운 말투가 나오도록 하세요. "이게 광고처럼 보이나?"라고 스스로 질문하고, 그렇다면 다시 찍으세요.',
      contentGuideEn:
        'Film yourself using the product naturally in your everyday spaces — your bedroom, kitchen, or car. Use trending background music and minimize scripting to keep your natural speech. Ask yourself "does this look like an ad?" — if yes, reshoot.',
    },
    {
      type: 'dont',
      title: '과학적 성분 설명만으로 영상을 채우지 마라',
      titleEn: "Don't fill the video with scientific ingredient explanations alone",
      detail:
        '과학적 성분 정보만을 단독으로 강조한 포스트는 전체 평균보다 낮은 매출을 기록했으며, 소셜 증거나 감성적 변화 스토리와 결합할 때만 효과가 있습니다. 성분 설명은 감성적 맥락 안에서 신뢰 보강 레이어로만 활용해야 합니다.',
      detailEn:
        'Posts leading primarily with scientific ingredient information underperformed the overall average, and uplift only occurs when paired with social proof or personal transformation stories. Ingredient explanations should only serve as a trust-reinforcement layer within an emotional narrative.',
      uplift: '과학 성분 단독 강조는 오히려 매출 하락 요인',
      upliftEn: 'Science-only emphasis actually depresses revenue performance',
      tags: ['과학적 성분', '신뢰 레이어', '소셜 증거'],
      tagsEn: ['Scientific ingredients', 'Trust layer', 'Social proof'],
      referencePosts: [P['5c16'], P['5c0e']],
    },
  ],
  topVideoPosts: [
    {
      rank: 1,
      title: 'POV 전·후 비교 | 카일리 제너 KO 디블로팅 파우더 | 무음 텍스트 오버레이',
      titleEn: 'POV Before-After | Kylie Jenner KO Debloating Powder | Silent Text Overlay',
      gmv: 'Revenue score: 1.011 (top overall)',
      creatorProfile: 'White female, age 30, US',
      description:
        '"POV: 카일리 제너의 새 디블로팅 파우더를 써봤다…"라는 텍스트 오버레이로 시작. 젖은 머리, 피부 결이 보이는 자연스러운 \'사용 전\' 모습을 먼저 보여주고, "3주 후" 타임스탬프와 함께 윤기 있고 정돈된 피부로 변한 \'사용 후\' 장면으로 전환. 마지막에 KO by Kylie Jenner 제품 패킷 공개. "빨리요, 엄청 빠르게 품절되고 있어요"로 마무리. 음성 설명 없이 텍스트와 영상만으로 스토리 완성.',
      descriptionEn:
        'Opens with the text overlay "POV: you tried Kylie Jenner\'s new debloat powder…" First shows a natural \'before\' look with wet hair and visible skin texture, then cuts to a radiant, smooth \'after\' look with the timestamp "3 weeks later." Closes with a reveal of the KO by Kylie Jenner product packet and "be quick, it\'s selling out FAST." The entire story is told through text and visuals alone — no voice-over.',
      reasons: [
        '카일리 제너 이름이 제목에서 즉각 호기심 유발',
        '실제 피부 질감이 보이는 비필터 \'전\' 화면이 진정성 극대화',
        '명확한 시간 증거로 변화 신뢰도 상승',
        '"빠르게 품절" FOMO 메시지',
        '액체형 드링크 믹스 제품',
      ],
      reasonsEn: [
        "Kylie Jenner's name in the title instantly sparks curiosity",
        "Unfiltered 'before' shot with visible skin texture maximizes authenticity",
        'Clear timeframe provides concrete proof of transformation',
        '"Selling out FAST" FOMO message',
        'Liquid drink mix product format',
      ],
      ...P['5c13'],
    },
    {
      rank: 2,
      title: '60대 히스패닉 여성 | 스페인어 직접 증언 | Weem 비건 젤리 서플리먼트',
      titleEn: 'Hispanic Woman in Her 60s | Spanish Testimonial | Weem Vegan Gummy Supplement',
      gmv: 'Revenue score: 1.002 (top overall)',
      creatorProfile: 'Hispanic female, age 60, US',
      description:
        '화면 가득 채운 클로즈업으로 제품(Weem 젤리)을 들고 스페인어로 직접 설명. 식물성·비건·비GMO·글루텐프리 강조. "매일 2알씩, 30일이면 확실히 달라진다"는 보증. 배경음악 없음, 로컬 홈 세팅, 비필터 자연 피부.',
      descriptionEn:
        'Fills the frame with a close-up while holding the product (Weem gummies) and speaking directly in Spanish. Highlights plant-based, vegan, non-GMO, and gluten-free credentials. Closes with "2 gummies a day — in 30 days you\'ll definitely see a difference." No background music, home setting, unfiltered natural skin.',
      reasons: [
        '스페인어 히스패닉 시장의 소외된 수요 정밀 타겟팅',
        '60대라는 나이가 강력한 또래 증거로 작용',
        '화려함 없는 투명한 개인 증언이 광고 피로감 돌파',
        '셀럽 브랜드 없이도 성공한 예외적 사례',
      ],
      reasonsEn: [
        'Precisely targets the underserved demand of the Spanish-speaking Hispanic market',
        'At age 60, the creator provides powerful peer validation',
        'Unpolished, transparent personal testimony cuts through ad fatigue',
        'Exceptional success without a celeb brand',
      ],
      ...P['5cc9'],
    },
    {
      rank: 3,
      title: '3가지 맛 테이스트 테스트 | 카일리 K2O | 중동계 남성 크리에이터',
      titleEn: '3-Flavor Taste Test | Kylie K2O | Middle Eastern Male Creator',
      gmv: 'Revenue score: 0.859 (above average)',
      creatorProfile: 'Middle Eastern male, age 25, English, US',
      description:
        '딸기라이치, 피치, 수박라임 3가지 맛의 KO by Kylie Jenner 드링크를 유리잔에 담아 순차적으로 시음. 각각의 맛에 다른 표정 반응(고개 끄덕임, 찡그림). 포스트 캡션은 "이 중 하나는 맛없어요 🤢"로 호기심 유발. "새로운 브랜드 런칭 제품은 빨리 품절되니 기다리지 마세요"로 마무리.',
      descriptionEn:
        'Pours KO by Kylie Jenner drinks — strawberry lychee, peach, and watermelon lime — into glasses and tastes each sequentially, showing distinct facial reactions (nods, grimaces). Caption reads "One of these was gross 🤢." Closes with "new brand launch means it sells out fast — don\'t wait."',
      reasons: [
        '"이 중 하나는 맛없다"는 갈등 훅이 영상 완주를 유도',
        '3가지 비교라는 구체성이 정보 가치 창출',
        '실제 마시는 장면(소리, 표정)이 감각적 공감',
        '긴급성 CTA로 전환 확정',
      ],
      reasonsEn: [
        'The conflict hook "one of these tastes gross" drives video completion',
        'Three-flavor comparison creates concrete informational value',
        'Drinking moment (sound + expression) generates sensory empathy',
        'Urgency CTA locks in conversions',
      ],
      ...P['5c16'],
    },
    {
      rank: 4,
      title: '차 안 고백 포맷 | K2O 셀룰라이트 비밀 공개 | 베리솔 콜라겐 과학적 설명',
      titleEn: 'In-Car Confessional | K2O Anti-Cellulite Secret Reveal | Verisol Collagen Science',
      gmv: 'Revenue score: 0.668 (above average)',
      creatorProfile: 'White female, age 25, English, US',
      description:
        '주차된 차 안에서 자연광으로 셀카 촬영. "카일리 제너는 어떻게 셀룰라이트 없이 저런 몸을 가졌을까? 유전이 아닙니다"로 갈등 훅 시작. K2O 제품 소개 후 임상 데이터와 고객 후기 스크린샷을 화면 속 화면(PIP) 방식으로 삽입. "여름 전에 품절되고 있어요"로 마무리.',
      descriptionEn:
        'Shot as a selfie in a parked car with natural light. Opens with the conflict hook: "How does Kylie Jenner have zero cellulite? It\'s not genetics." Introduces K2O and inserts clinical data and customer review screenshots via picture-in-picture. Closes with "selling out before summer."',
      reasons: [
        '차 안 촬영이 친구에게 비밀 전수하는 듯한 친밀감 조성',
        '셀럽 몸매에 대한 대중의 호기심을 훅으로 정확히 포착',
        '과학적 데이터가 감성 스토리 위에 신뢰 레이어로 추가',
        '픽처인픽처 편집으로 짧은 시간에 많은 정보 전달',
      ],
      reasonsEn: [
        'Car-confessional format creates intimacy, like sharing a secret with a friend',
        "Hooks into the audience's existing curiosity about the celebrity's body",
        'Clinical data adds a trust layer on top of the emotional story',
        'Picture-in-picture editing delivers high information density in a short runtime',
      ],
      ...P['5c0e'],
    },
    {
      rank: 5,
      title: '스페인어 POV 스킷 | 친구에게 K2O 권하기 | 히스패닉 25~30대 여성',
      titleEn: 'Spanish POV Skit | Sharing K2O with a Friend | Hispanic Woman in Her Late 20s',
      gmv: 'Revenue score: 0.404 (above average)',
      creatorProfile: 'Hispanic female, age 28, Spanish, US',
      description:
        '1인칭 POV 촬영으로 소파에 앉은 친구에게 드링크를 건네는 장면으로 시작. 친구는 처음에 거부하다가 한 모금 마신 뒤 깜짝 놀라는 표정으로 변화. 제품 패키지를 열어 성분을 설명하고, 어머니날 한정 프로모션 및 "빠르게 품절" 긴급성을 강조.',
      descriptionEn:
        'Opens in first-person POV as the creator hands a drink to a friend sitting on a sofa. The friend initially refuses, then takes a sip and reacts with surprise. The creator unpacks the product and explains the ingredients. Closes with a Mother\'s Day limited promotion and "selling out fast" urgency.',
      reasons: [
        '거부→수용의 드라마틱한 감정 전환이 시청 완주율 극대화',
        '스페인어 히스패닉 커뮤니티 타겟팅으로 친밀감',
        'POV 스킷이 "직접 권유받는" 몰입 경험',
        '시즌 프로모션으로 긴급성 정당화',
      ],
      reasonsEn: [
        'Dramatic emotional arc — refusal → acceptance — maximizes view-through rate',
        'Spanish-language content builds authentic intimacy within the Hispanic community',
        'First-person POV creates the immersive experience of being directly recommended',
        'Season-based promotion justifies and legitimizes the urgency',
      ],
      ...P['5c10'],
    },
  ],
};
